import nluApi from '../../api/nlu'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    isPatternView: false,
    patterns: {
      loading: false,
      value: []
    }
  },

  actions: {
    async createPatternPair (
      { state, commit, dispatch, rootState, rootGetters },
      { applicationName, intentName, intentType, patternText, patternEntities }
    ) {
      try {
        const res = await nluApi.createPatternPair({
          kbId: rootState.knowledgebase.current,
          applicationName,
          intentName,
          intentType,
          patternText,
          patternEntities
        })

        const { pattern, application } = res
        const { allApplications } = rootState.knowledgebase
        pattern.appId = pattern.application
        const updatedUtterancesValue = [_.omit(pattern, ['kbId', 'application', 'versionId']), ...state.patterns.value]
        commit('SET_PATTERNS', { value: updatedUtterancesValue })
        if (allApplications.every(app => app.id !== application.appId)) {
          commit(
            'knowledgebase/SET_ALL_APPLICATIONS',
            [
              _.pick(application, ['name', 'id', 'luisId']),
              ...allApplications
            ],
            { root: true }
          )
        }
        dispatch('knowledgebase/_updateModelModifiedDate', null, { root: true })
      } catch (error) {
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.patterns.createPatternPair.errorNotification.title', error },
          { root: true }
        )
      }
    },

    async updatePattern ({ state, commit, dispatch, rootGetters, rootState }, { appId, loading, ...pattern }) {
      try {
        const loadingOn = _.map(state.patterns.value, obj =>
          obj.id === pattern.id ? { ...obj, loading: true } : obj)

        commit('SET_PATTERNS', { value: loadingOn })
        nluApi.updatePattern({
          kbId: rootState.knowledgebase.current,
          appId,
          pattern
        })
        const loadingOff = _.map(state.patterns.value, obj => obj.id === pattern.id
          ? { ...obj, ...pattern, loading: false }
          : obj
        )

        commit('SET_PATTERNS', { value: loadingOff })
        dispatch('knowledgebase/_updateModelModifiedDate', null, { root: true })
        dispatch('knowledgebase/statuses/fetchStatus', null, { root: true })
      } catch (error) {
        const loadingOff = _.map(state.patterns.value, obj =>
          obj.id === pattern.id ? { ...obj, loading: false } : obj)

        commit('SET_PATTERNS', { value: loadingOff })
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.patterns.updatePattern.errorNotification.title', error },
          { root: true }
        )
      }
    },

    async deletePattern ({ rootState, state, commit, dispatch, rootGetters }, { id, appId }) {
      try {
        const loadingOn = _.map(state.patterns.value, obj =>
          obj.id === id ? { ...obj, loading: true } : obj)

        commit('SET_PATTERNS', { value: loadingOn })
        nluApi.deletePattern({ id, appId, kbId: rootState.knowledgebase.current })

        const loadingOff = _.reject(state.patterns.value, ['id', id])
        commit('SET_PATTERNS', { value: loadingOff })
        dispatch('knowledgebase/_updateModelModifiedDate', null, { root: true })
        dispatch('knowledgebase/statuses/fetchStatus', null, { root: true })
      } catch (error) {
        const loadingOff = _.map(state.patterns.value, obj =>
          obj.id === id ? { ...obj, loading: false } : obj)

        commit('SET_PATTERNS', { value: loadingOff })
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.patterns.deletePattern.errorNotification.title', error },
          { root: true }
        )
      }
    }
  },

  mutations: {
    SET_PATTERNS (state, { loading = false, value = [] }) {
      return _.set(state, 'patterns', { loading, value })
    },

    SET_IS_PATTERN_VIEW (state, value) {
      state.isPatternView = value
    }
  }
}
